export default "__VITE_ASSET__yG40u_fe__"